export const Page404: React.FunctionComponent = () => {
  
    return (
      <h1>404</h1>
    );
  
  }